import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import NewsletterArea from "../containers/global/newsletter";
import PageBanner from "../containers/global/page-banner";
import TeampPageContainer from "../containers/team-page-container";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index";

const TeamPage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO title="Leadership Team | NeoGrowth | Lending simplified. Growth amplified." />
                <div className="wrapper">
                    <Header />
                    <PageBanner
                        title="Leadership Team"
                        excerpt="NeoGrowth's leadership team brings together diversity of talent and a wealth of experience."
                        image="/images/banner/page/leadership.png"
                    />
                    <TeampPageContainer />
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default TeamPage;
